import React from 'react';

interface FidelityHeaderProps {
    title: string;
    subtitle?: string;
    description?: string;
}

const FidelityHeader = ({ title, subtitle, description }: FidelityHeaderProps) => {

    return (
        <div className='flex flex-col gap-2'>
            <h1 className="text-3xl font-bold text-shopfood-title text-center text-gray-700">
                {title}
            </h1>
            {subtitle && (
                <h2 className="text-xl font-medium text-center">
                    {subtitle}
                </h2>
            )}
            {description && (
                <p className="text-center leading-5 px-2">
                    {description}
                </p>
            )}
        </div>
    );
};

export default FidelityHeader;
